import { useMemo } from "react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingActions } from "@/components/site/FloatingActions";
import { Hero } from "@/components/home/Hero";
import { Gastronomy } from "@/components/home/Gastronomy";
import { Marquee, Signature, NightBanner } from "@/components/home/Highlights";
import { About, GalleryGrid, ReviewsSection, InstagramCTA } from "@/components/home/Story";
import { ReservationContact } from "@/components/home/Reservation";
import { FAQ, buildFaqs } from "@/components/home/FAQ";
import { useSite } from "@/context/SiteContext";
import { useSeo, restaurantSchema } from "@/lib/seo";

export default function Home() {
  const { settings } = useSite();
  const faqs = useMemo(() => buildFaqs(settings), [settings]);
  const jsonLd = useMemo(() => restaurantSchema(settings, faqs), [settings, faqs]);
  useSeo({
    title: settings.seo_title || "Yeni Mercan Restoran Buca | 7/24 Açık Ev Yemekleri, Kahvaltı, Kokoreç & Premium Izgara",
    description: settings.seo_description || "Yeni Mercan Restoran Buca, İzmir: 7/24 açık. Serpme kahvaltı, ev yemekleri, çorba, kokoreç ve premium ızgaralar. Online rezervasyon ve QR menü.",
    path: "/",
    jsonLd,
  });
  return (
    <div className="bg-[#140D0B] overflow-x-hidden" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Gastronomy />
        <Signature />
        <NightBanner />
        <About />
        <GalleryGrid />
        <ReviewsSection />
        <FAQ faqs={faqs} />
        <ReservationContact />
        <InstagramCTA />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
